var _excluded = ["label", "size", "tooltip", "required", "error", "readOnly", "colon", "status", "hiddenLabel", "forceShowError", "forceColumn", "disableOverflow", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * done
 */
import { useField } from '@formily/react';
import React from 'react';
import { wrapReactionHook } from "../../hooks";
import { useCssInJs } from "../../hooks";
import cx from 'classnames';
import { genFormItemStyle } from "./styles";
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
export var FormItem = wrapReactionHook(function (props) {
  var label = props.label,
    _props$size = props.size,
    size = _props$size === void 0 ? 'normal' : _props$size,
    tooltip = props.tooltip,
    staticRequired = props.required,
    staticError = props.error,
    staticReadOnly = props.readOnly,
    colon = props.colon,
    _props$status = props.status,
    staticStatus = _props$status === void 0 ? 'normal' : _props$status,
    hiddenLabel = props.hiddenLabel,
    forceShowError = props.forceShowError,
    forceColumn = props.forceColumn,
    disableOverflow = props.disableOverflow,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var field = useField();
  var prefix = 'form-item';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genFormItemStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var readOnly = 'readOnly' in field ? field.readOnly : staticReadOnly;
  var required = 'required' in field ? field.required : staticRequired;
  var title = label || field.title;
  var error = 'selfErrors' in field ? field.selfErrors : staticError;
  return wrapSSR( /*#__PURE__*/React.createElement("div", _extends({
    className: cx(hashId, prefix)
  }, rest), title ? /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, "".concat(prefix, "-label"))
  }, required && !readOnly ? /*#__PURE__*/React.createElement("span", {
    className: cx(hashId, "".concat(prefix, "-required"))
  }, "*") : null, title, tooltip ? /*#__PURE__*/React.createElement("span", {
    className: cx(hashId, "".concat(prefix, "-help"))
  }, /*#__PURE__*/React.createElement(Tooltip, {
    trigger: "hover",
    title: tooltip
  }, /*#__PURE__*/React.createElement(QuestionCircleOutlined, null))) : null, colon ? ':' : null) : null, /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, "".concat(prefix, "-content"))
  }, children), error ? /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, "".concat(prefix, "-error"))
  }, error) : null));
});